import PropTypes from 'prop-types';

import Button from '@zenbusiness/zui/Button';
import Text from '@zenbusiness/zui/Text';

import useInvoiceLink from '../../hooks/useInvoiceLink';

function InvoiceRow({ invoice }) {
  const {
    invoiceId,
    chargeDate,
    amount,
    paymentMethod
  } = invoice;

  const { fetchInvoiceLink, loading } = useInvoiceLink(invoiceId);

  const formatPaymentMethod = () => {
    const { brand, last4 } = paymentMethod;
    const capitalizedBrand = `${brand.charAt(0).toUpperCase()}${brand.slice(1)}`;
    return `${capitalizedBrand} x${last4}`;
  };

  const formatAmount = () => `$${amount}`;

  const handleDownload = async () => {
    const url = await fetchInvoiceLink();
    if (url) {
      window.open(url, '_blank');
    }
  };

  return (
    <tr>
      <td>
        <Text variant="body2">{chargeDate}</Text>
      </td>
      <td>
        <Text variant="body2">{formatPaymentMethod()}</Text>
      </td>
      <td>
        <Text variant="body2">{formatAmount()}</Text>
      </td>
      <td>
        <Button
          variant="contained"
          size="small"
          onClick={handleDownload}
          disabled={loading}
          clickstreamProps={{ elementName: 'view_download_invoice_button' }}
        >
          View/Download
        </Button>
      </td>
    </tr>
  );
}

InvoiceRow.propTypes = {
  invoice: PropTypes.shape({
    invoiceId: PropTypes.string.isRequired,
    chargeDate: PropTypes.string.isRequired,
    amount: PropTypes.string.isRequired,
    paymentMethod: PropTypes.shape({
      brand: PropTypes.string.isRequired,
      last4: PropTypes.string.isRequired
    }).isRequired
  }).isRequired
};

export default InvoiceRow;
